import React, { useMemo, useEffect } from "react";
import { connect } from "react-redux";
import CardItem from "components/card/CardItem";
import { MdPeopleAlt } from "react-icons/md";
import UserAvatar from "assets/img/avatars/user.png";
import { 
	getTopFarmers
} from "../../../../redux/dashboard/dashboardState";
import { Table } from 'antd';
import {displayFullName} from '../../../../utils/index';

function FarmersList({getTableData, recordList, requesting, success, error, ...props}) {

  useEffect(() => {
    getTableData(null);
    }, [getTableData]);


  const columns = [
		{
        title: `Name`,
        dataIndex: 'user_id',
        key: 'user_id',
        width: '50%',
        render:(user_id,record) => 
        <div className="flex items-center gap-2">   
          <img
            className="h-10 w-10 rounded-full"
            src={UserAvatar}
            alt="User Avatar"
          />                      
          <p className="text-sm font-medium text-theme-700 dark:text-white">
            {displayFullName(record)}
          </p>
        </div>
    },
    {
        title: `Animals`,
        dataIndex: 'total',
        key: 'total',
        width: '25%',
        render:(total) => <span>{total}</span>
    },
    {
        title: `Points`,
        dataIndex: 'points',
        key: 'points',
        width: '25%',
        render:(points) => <span>0</span>
    },
  ];

  return (
    <CardItem 
      icon={<MdPeopleAlt className="h-6 w-6 text-theme-500 dark:text-theme-400"/>}
      title={"Top Farmers"}
      cardMenu={
        <a className="card-menu-button" href='/console/top-farmers'>
          More Preview
        </a>
      }
      extra={"h-[750px] w-full"}
      >
      
      <div className="h-[680px] pt-4 w-full overflow-x-scroll px-4 md:overflow-x-hidden overflow-y-auto">

        <Table
          dataSource={recordList}
          columns={columns} 
          rowKey={(record) => record.id}
          pagination={false}
        />
        
      </div>
      
    </CardItem>
  );
}

const mapStateToProps = (state) => ({
    requesting: state.dashboard.topFarmers?.requesting,
    success: state.dashboard.topFarmers?.success,
    error: state.dashboard.topFarmers?.error,
    recordList: state.dashboard.topFarmers?.items,
});

const mapDispatchToProps = (dispatch) => ({
  getTableData: (filters) => dispatch(getTopFarmers(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FarmersList);
